import React, { FC, useEffect, useState } from 'react';
import { View, Text } from 'react-native';

import Link from '../LinkBase';

export type ButtonBaseProps = {
  containerStyle?: any;
  disabled?: boolean;
  disabledContainerStyle?: any;
  hoverTextStyle?: any;
  hoverStyle?: any;
  onPress: (e: any) => void;
  textStyle?: any;
  title: string;
  url?: string;
};

//    TODO: ADD disabled and loading props
const ButtonBase: FC<ButtonBaseProps> = (props) => {
  const {
    containerStyle,
    disabled,
    disabledContainerStyle,
    hoverStyle,
    textStyle,
    hoverTextStyle,
    onPress,
    title,
    url,
  } = props;
  const [isHovering, setHoverState] = useState(false);
  const onHover = (isHovering) => {
    setHoverState(isHovering);
  };

  const getTextStyle = () => {
    if (isHovering && !disabled) {
      return hoverTextStyle;
    }
    return textStyle;
  };
  const getContainerStyle = () => {
    if (isHovering && !disabled) {
      return hoverStyle;
    } else if (disabled) {
      return disabledContainerStyle;
    }
    return containerStyle;
  };

  return (
    <Link
      accessibilityRole="button"
      disabled={disabled}
      onHover={onHover}
      onPress={onPress}
      url={url}
    >
      <View style={getContainerStyle()}>
        <Text style={getTextStyle()}>{title}</Text>
      </View>
    </Link>
  );
};

export default ButtonBase;

// const [ isPressed, setIsPressed ] = useState(false)
// const [ pressedOutStyle, setPressedOutStyle ] = useState(textStyle)

// const onPressIn = () => {
// 	setIsPressed(true)
// }
// const onPressOut = () => {
// 	setIsPressed(false)
// }
